<template>
    <div id="app">
        <ejs-tab id="element"  ref='userTabs' :selectedItem="selectedItem">
            <e-tabitems>
                <e-tabitem :header='headerText1'  :content='userTemplate'></e-tabitem>
                <e-tabitem :header='headerText2'  :content='groupsAndPermissionsTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import UserForm from '@/views/administration/users/User.vue';
    import groupsAndPermissionsForm from '@/views/administration/users/UserGroup.vue';
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {
                headerText1: { text: 'Users' },
                headerText2: { text: 'Groups and Permissions' },
                propsData: null,
                selectedItem: this.$store.state.isGroupUserTabLast ? 1: 0,
                userTemplate: function () {
                    return {
                        template: {
                            extends: UserForm
                        }
                    }
                },
                groupsAndPermissionsTemplate: function () {
                    return {
                        template: {
                            extends: groupsAndPermissionsForm
                        }
                    }
                }
            }
        },
        mounted: function () {
            if (!this.$store.state.permissions["Permissions.Users.View"]) {
                this.$refs.userTabs.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.UserGroups.View"]) {
                this.$refs.userTabs.hideTab(1);
            }

        },
    }
</script>

<style scoped>
</style>